import React from "react";
import { Footer } from "../Footer";
import NavBarTools from "../NavBarTools";
import GlobalStyles from "../styles/global";
import "../styles/fonts.css";
import * as S from "./styled";

export function Layout({ layoutName, children, cleanFooter = false }) {
  return (
    <>
      <GlobalStyles />
      <S.LayoutWrapper>
        {(() => {
          switch (layoutName) {
            case "page-talents":
              return (
                <>
                  <NavBarTools navName="page-talents" />
                  <S.MainWrapper id="content">{children}</S.MainWrapper>
                  <Footer isCleanFooter />
                </>
              );

            case "page-form-no-scape-no-back":
              return (
                <>
                  <NavBarTools navName="page-form-no-scape-no-back" />
                  <S.MainWrapper id="content">{children}</S.MainWrapper>
                  <Footer isCleanFooter />
                </>
              );

            case "no-scape-partern-stack":
              return (
                <>
                  <NavBarTools navName="no-scape-partern-stack" />
                  <S.MainWrapper id="content">{children}</S.MainWrapper>
                  <Footer isCleanFooter />
                </>
              );

            case "page-form-no-scape":
              return (
                <>
                  <NavBarTools navName="page-form-no-scape" />
                  <S.MainWrapper id="content">{children}</S.MainWrapper>
                  <Footer isCleanFooter />
                </>
              );

            case "thankyou-page":
              return (
                <>
                  <NavBarTools navName="thankyou-page" />
                  <S.OneWrapper id="content">{children}</S.OneWrapper>
                  <Footer isCleanFooter />
                </>
              );

            case "page-form-multi-step":
              return (
                <S.FormMultiStepMain id="content">
                  {children}
                </S.FormMultiStepMain>
              );

            default:
              return (
                <>
                  <NavBarTools />
                  <S.MainWrapper id="content">{children}</S.MainWrapper>
                  <Footer isCleanFooter />
                </>
              );
          }
        })()}
      </S.LayoutWrapper>
    </>
  );
}
